import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/platform-browser';

class ResizePipe {
    transform(imageUrl, width, height, anchor, mode, format, scale) {
        if (!imageUrl) {
            return imageUrl;
        }
        let val = `${imageUrl}`;
        if (width) {
            val = `${val}${this.separator(val)}width=${width}`;
        }
        if (height) {
            val = `${val}${this.separator(val)}height=${height}`;
        }
        if (anchor) {
            val = `${val}${this.separator(val)}anchor=${anchor}`;
        }
        if (mode) {
            val = `${val}${this.separator(val)}mode=${mode}`;
        }
        if (format) {
            val = `${val}${this.separator(val)}format=${format}`;
        }
        if (scale) {
            val = `${val}${this.separator(val)}scale=${scale}`;
        }
        return val;
    }
    separator(url) {
        return url.indexOf('?') >= 0 ? '&' : '?';
    }
}
ResizePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ResizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ResizePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ResizePipe, name: "resize" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ResizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'resize',
                }]
        }] });

class StripHtmlPipe {
    transform(value) {
        if (typeof window !== 'undefined') {
            const element = document.createElement('div');
            element.innerHTML = value;
            return element.innerText;
        }
        else {
            return value;
        }
    }
}
StripHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StripHtmlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
StripHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StripHtmlPipe, name: "stripHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StripHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'stripHtml'
                }]
        }] });

class TruncatePipe {
    transform(value, max = 20, stuffix = '...') {
        return value.length > max ? value.substring(0, max - stuffix.length) + stuffix : value;
    }
}
TruncatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TruncatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TruncatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TruncatePipe, name: "truncate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: TruncatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'truncate',
                }]
        }] });

class UrlRewritePipe {
    transform(value) {
        if (typeof value !== 'string') {
            return '';
        }
        return value
            .replace(/ /g, '-')
            .replace(/&/g, 'en')
            .replace(/!/g, '')
            .replace(/\./g, '')
            .replace(/,/g, '')
            .replace(/\?/g, '')
            .replace(/\+/g, '')
            .toLowerCase();
    }
}
UrlRewritePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UrlRewritePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
UrlRewritePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UrlRewritePipe, name: "urlRewrite" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UrlRewritePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'urlRewrite'
                }]
        }] });

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type = 'html') {
        switch (type) {
            case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SafePipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SafePipe, name: "safe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safe' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class ResizeHtmlImagesPipe {
    constructor() {
        // Inherited from CSS: $grid-breakpoints
        // is used to generate size attribute with collspans
        this.cssBreakPoints = {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1400,
        };
    }
    transform(htmlContent, width, height, imageSizes = [550, 800, 1200, 1600, 1920], 
    // How many cols does the image span on what breakpoint?
    // For example: { md: 4, xl: 3 } is the same as bootstrap .col-md-4 .col-xl-3 classes
    sizes) {
        if (!htmlContent) {
            return htmlContent;
        }
        let filters = ``;
        if (width) {
            filters = `${filters}${this.separator(filters)}width=${width}`;
        }
        if (height) {
            filters = `${filters}${this.separator(filters)}height=${height}`;
        }
        const regex = /(<img [^>]*src=['"])((?:https?\:)?\/\/[^'"]+)([^>]*)(>)/gim;
        let match;
        while ((match = regex.exec(htmlContent))) {
            // console.log(match[2]);
            const src = `${match[2].replace(' ', '%20')}`;
            const newElement = `${match[1]}${src}?width=${width || imageSizes[imageSizes.length - 1]}${match[3]} srcset="${this.srcSetAttr(src, imageSizes, width, height)}" sizes="${this.sizesAttr(sizes)}" loading="lazy" ${match[4]}`;
            htmlContent = htmlContent.replace(match[0], newElement);
        }
        return htmlContent;
    }
    separator(url) {
        return url.indexOf('?') >= 0 ? '&' : '?';
    }
    sizesAttr(sizes) {
        // So youll be able to make your own size property build
        if (!sizes) {
            return 'auto';
        }
        const sizeRules = [];
        // Sets for each container width an srcset (so for full width images)
        Object.keys(sizes).forEach(key => {
            const size = sizes[key];
            const breakpoint = this.cssBreakPoints[key];
            const width = (100 / 12) * size;
            sizeRules.push(`(min-width: ${breakpoint}px) ${width}vw`); // TODO calculate width with max width of container & vw?
        });
        return sizeRules.join(',').concat(', 100vw');
    }
    srcSetAttr(src, imageSizes, width, height) {
        const srcSetRules = [];
        const resize = new ResizePipe();
        imageSizes.forEach(imgWidth => {
            srcSetRules.push(
            // tslint:disable-next-line: max-line-length
            `${resize.transform(src, imgWidth, this.getAspectRatioHeight(width, height, imgWidth), null, null, null, null)}  ${imgWidth}w` // TODO calculate width with max width of container & vw?
            );
        });
        return srcSetRules.join(',');
    }
    getAspectRatioHeight(width, height, size) {
        if (!height || !width) {
            return null;
        }
        // ? What if only height is given ?
        const percentageDiff = (size - width) / width;
        const newHeight = Math.round((percentageDiff + 1) * height);
        return newHeight;
    }
}
ResizeHtmlImagesPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ResizeHtmlImagesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ResizeHtmlImagesPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ResizeHtmlImagesPipe, name: "resizeHtmlImages" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ResizeHtmlImagesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'resizeHtmlImages',
                }]
        }], ctorParameters: function () { return []; } });

const pipes$1 = [ResizePipe, SafePipe, StripHtmlPipe, TruncatePipe, UrlRewritePipe, ResizeHtmlImagesPipe];
class StringPipesModule {
}
StringPipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringPipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StringPipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringPipesModule, declarations: [ResizePipe, SafePipe, StripHtmlPipe, TruncatePipe, UrlRewritePipe, ResizeHtmlImagesPipe], imports: [CommonModule], exports: [ResizePipe, SafePipe, StripHtmlPipe, TruncatePipe, UrlRewritePipe, ResizeHtmlImagesPipe] });
StringPipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringPipesModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringPipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...pipes$1],
                    exports: [...pipes$1],
                    imports: [CommonModule],
                }]
        }] });

class SearchPipe {
    transform(items, searchText) {
        if (!items) {
            return [];
        }
        if (!searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.toLowerCase().indexOf(searchText) > -1;
        });
    }
}
SearchPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SearchPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchPipe, name: "search" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'search'
                }]
        }] });

/*
 *      Example use
 *      Basic Array of single type: *ngFor="let todo of todoService.todos | orderBy : '-'"
 *      Multidimensional Array Sort on single column: *ngFor="let todo of todoService.todos | orderBy : ['-status']"
 *      Multidimensional Array Sort on multiple columns: *ngFor="let todo of todoService.todos | orderBy : ['status', '-title']"
 */
class SortByLengthPipe {
    transform(arr, key) {
        if (!arr || !Array.isArray(arr) || !arr.every(obj => Array.isArray(obj[key]))) {
            return arr;
        }
        else {
            return arr.sort((a, b) => b[key].length - a[key].length);
        }
    }
}
SortByLengthPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortByLengthPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortByLengthPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortByLengthPipe, name: "sortByLength", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortByLengthPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'sortByLength', pure: false }]
        }] });

/*
 *      Example use
 *      Basic Array of single type: *ngFor="let todo of todoService.todos | orderBy : '-'"
 *      Multidimensional Array Sort on single column: *ngFor="let todo of todoService.todos | orderBy : ['-status']"
 *      Multidimensional Array Sort on multiple columns: *ngFor="let todo of todoService.todos | orderBy : ['status', '-title']"
 */
class SortByPipe {
    constructor() {
        this.value = [];
    }
    static _orderByComparator(a, b) {
        if (a === null || typeof a === "undefined") {
            a = 0;
        }
        if (b === null || typeof b === "undefined") {
            b = 0;
        }
        if ((isNaN(parseFloat(a)) ||
            !isFinite(a)) ||
            (isNaN(parseFloat(b)) || !isFinite(b))) {
            // Isn"t a number so lowercase the string to properly compare
            a = a.toString();
            b = b.toString();
            if (a.toLowerCase() < b.toLowerCase()) {
                return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
                return 1;
            }
        }
        else {
            // Parse strings as numbers to compare properly
            if (parseFloat(a) < parseFloat(b)) {
                return -1;
            }
            if (parseFloat(a) > parseFloat(b)) {
                return 1;
            }
        }
        return 0; // equal each other
    }
    transform(input, config = "+") {
        if (!input) {
            return input;
        }
        // make a copy of the input"s reference
        this.value = [...input];
        let value = this.value;
        if (!Array.isArray(value)) {
            return value;
        }
        if (!Array.isArray(config) || (Array.isArray(config) && config.length === 1)) {
            let propertyToCheck = !Array.isArray(config) ? config : config[0];
            let desc = propertyToCheck.substr(0, 1) === "-";
            // Basic array
            if (!propertyToCheck || propertyToCheck === "-" || propertyToCheck === "+") {
                return !desc ? value.sort() : value.sort().reverse();
            }
            else {
                let property = propertyToCheck.substr(0, 1) === "+" || propertyToCheck.substr(0, 1) === "-"
                    ? propertyToCheck.substr(1)
                    : propertyToCheck;
                return value.sort(function (a, b) {
                    let aValue = a[property];
                    let bValue = b[property];
                    let propertySplit = property.split(".");
                    if (typeof aValue === "undefined" && typeof bValue === "undefined" && propertySplit.length > 1) {
                        aValue = a;
                        bValue = b;
                        for (let j = 0; j < propertySplit.length; j++) {
                            aValue = aValue[propertySplit[j]];
                            bValue = bValue[propertySplit[j]];
                        }
                    }
                    return !desc
                        ? SortByPipe._orderByComparator(aValue, bValue)
                        : -SortByPipe._orderByComparator(aValue, bValue);
                });
            }
        }
        else {
            // Loop over property of the array in order and sort
            return value.sort(function (a, b) {
                for (let i = 0; i < config.length; i++) {
                    let desc = config[i].substr(0, 1) === "-";
                    let property = config[i].substr(0, 1) === "+" || config[i].substr(0, 1) === "-"
                        ? config[i].substr(1)
                        : config[i];
                    let aValue = a[property];
                    let bValue = b[property];
                    let propertySplit = property.split(".");
                    if (typeof aValue === "undefined" && typeof bValue === "undefined" && propertySplit.length > 1) {
                        aValue = a;
                        bValue = b;
                        for (let j = 0; j < propertySplit.length; j++) {
                            aValue = aValue[propertySplit[j]];
                            bValue = bValue[propertySplit[j]];
                        }
                    }
                    let comparison = !desc
                        ? SortByPipe._orderByComparator(aValue, bValue)
                        : -SortByPipe._orderByComparator(aValue, bValue);
                    // Don"t return 0 yet in case of needing to sort by next property
                    if (comparison !== 0) {
                        return comparison;
                    }
                }
                return 0; // equal each other
            });
        }
    }
}
SortByPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortByPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SortByPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortByPipe, name: "sortBy", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: SortByPipe, decorators: [{
            type: Pipe,
            args: [{ name: "sortBy", pure: false }]
        }] });

class StringJoinPipe {
    transform(value, field, separator = ', ') {
        return value.map(a => a[field]).join(separator);
    }
}
StringJoinPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringJoinPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
StringJoinPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringJoinPipe, name: "stringJoin" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StringJoinPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'stringJoin'
                }]
        }] });

const pipes = [SearchPipe, SortByLengthPipe, SortByPipe, StringJoinPipe];
class ArrayPipesModule {
}
ArrayPipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ArrayPipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ArrayPipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ArrayPipesModule, declarations: [SearchPipe, SortByLengthPipe, SortByPipe, StringJoinPipe], imports: [CommonModule], exports: [SearchPipe, SortByLengthPipe, SortByPipe, StringJoinPipe] });
ArrayPipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ArrayPipesModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ArrayPipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...pipes],
                    exports: [...pipes],
                    imports: [CommonModule],
                }]
        }] });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, imports: [StringPipesModule, ArrayPipesModule], exports: [StringPipesModule, ArrayPipesModule] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, imports: [[StringPipesModule, ArrayPipesModule], StringPipesModule, ArrayPipesModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [StringPipesModule, ArrayPipesModule],
                    exports: [StringPipesModule, ArrayPipesModule],
                }]
        }] });

/*
 * Public API Surface of pipes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ArrayPipesModule, PipesModule, ResizeHtmlImagesPipe, ResizePipe, SafePipe, SearchPipe, SortByLengthPipe, SortByPipe, StringJoinPipe, StringPipesModule, StripHtmlPipe, TruncatePipe, UrlRewritePipe };
